import mixpanel from 'mixpanel-browser';
import {extractUTMParams} from '../utils/common';
import {PATTERNS} from '../utils/constants';
import api, {getURL, resolver, ResolverTypes} from '../api';

const getIp = (): Promise<ResolverTypes> => {
  return resolver(getURL(api.getCountryByIp.ENDPOINTS.byIp()), {
    method: 'GET',
  });
};

function getDistincId() {
  if (!mixpanel) {
    return null;
  }
  let distincID;
  try {
    distincID = mixpanel.get_distinct_id();
    return distincID;
  } catch (e) {
    console.error(e);
    return null;
  }
}

function mixpanelTrackWithUTM(eventName: string) {
  if (!mixpanel) {
    return;
  }
  try {
    mixpanel.track(eventName, extractUTMParams());
  } catch (e) {
    console.error(e);
  }
}

function mixpanelTrack(eventName: string, params: {[key: string]: string}) {
  if (!mixpanel) {
    return;
  }
  const UTMParams = extractUTMParams();
  try {
    const allParams = {...params, ...UTMParams};
    mixpanel.track(eventName, allParams);
  } catch (e) {
    console.error(e);
  }
}

function mixpanelAlias(email: string) {
  const isEmail = PATTERNS.email.test(email);

  if (!mixpanel) {
    return;
  }

  try {
    if (isEmail) {
      mixpanel.alias(email);
    } else {
      console.error(`Not an email address ${email}, cannot use it for alias`);
    }
  } catch (e) {
    console.error(e);
  }
}

function mixpanelIdentify(email: string) {
  const isEmail = PATTERNS.email.test(email);

  if (!mixpanel) {
    return;
  }

  try {
    if (isEmail) {
      mixpanel.identify(email);
    } else {
      console.error(`Not an email address ${email}, cannot use it for identifying`);
    }
  } catch (e) {
    console.error(e);
  }
}

function mixpanelReset() {
  if (!mixpanel) {
    return;
  }

  try {
    mixpanel.reset();
  } catch (e) {
    console.error(e);
  }
}

function initMixpanel(token?: string) {
  if (!token) {
    return;
  }

  mixpanel.init(token, {
    loaded: async mixpanel => {
      let distinctId = mixpanel.get_distinct_id();
      const isEmail = PATTERNS.email.test(distinctId);
      const {data, error} = await getIp();
      const ip = error ? distinctId : data.ip;

      if (!isEmail) {
        distinctId = ip;
        // mixpanel.alias(distinctId);
      }
      mixpanel.identify(distinctId);
      localStorage.setItem('distinct_id', JSON.stringify(distinctId));
    },
  });
}

export {
  initMixpanel,
  mixpanelAlias,
  mixpanelTrack,
  mixpanelIdentify,
  mixpanelReset,
  mixpanelTrackWithUTM,
  getDistincId,
};
